import React from 'react'

import cloudinary from '~/utils/cloudinary'

import { GoogleIconContainer } from './elements'

const logoUrl = cloudinary.getFullUrl('v1563875361/sellers/g-icon.svg')

const GoogleIcon = () => {
  return (
    <GoogleIconContainer>
      <img alt="google" src={logoUrl} />
    </GoogleIconContainer>
  )
}

export default GoogleIcon
